import Vue from 'vue';
import { Action, Getter } from 'vuex-class';
import { APPOINTMENT_NAMESPACE } from '@/_store/appointment';
import { sendMessage } from '@/_utils';

export default class ConfirmAppointment extends Vue {

  public mounted() {

  }

  get logoUrl() {
    return this.$route.query.logo || '';
  }

  get buttonBackColor() {
    
    return '#' + this.$route.query.buttonBackColor || '';
  }

  get buttonFontColor() {
    return '#' + this.$route.query.buttonFontColor || '';
  }

  get getConfirmText() {
    const str = this.$t('CONTACT_APPOINTMENT_FEEDBACK') as string;
    return str.replace('{PROPERTY_ADDRESS}', `<b>${this.$route.query.propertyAddress as string}</b>`).replace('{APPOINTMENT_DATE_TIME}', `<b>${this.$route.query.appointmentDateTime as string}</b>`)
  }

  public handleBackToCalendar() {
    sendMessage({ type: 'hide-modal', mess: 'hide-modal' });
  }
}
